<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id ? actions :[]"
    :form="form"
    :onFetchData="onFetchData"
    :onFormSubmit="handleSubmit"
    :title="$t('menu.electricity')"
    resource="user_request/electricities"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../../admin_grapes/user_requests.js';

@Component
export default class UserRequestElectricities extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'number_cont',
      'state_eq',
      'user_phone_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'number',
      'amount_cents',
      {
        prop: 'user',
        label: this.$t('model.user'),
        minWidth: 150,
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link to={{ name: 'users.show', params: { id: value.id } }}>{ value.miapay_wallet_holder_attributes.phone }</bean-link>;
          }
        }
      },
      'state',
      'remark',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'remark',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'user_request/electricities.edit', params: { id: row.id } },
          can: 'user_requests.update'
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'user_requests.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/user_requests', { ...this.$route.query, type_eq: 'UserRequest::Electricity' });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/user_requests/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {
        data: {}
      }
    }
  }

  async handleSubmit({ data, type }) {
    if (type === 'edit') {
      const { remark } = data;
      await this.$request.put(`/user_requests/${data.id}`, { remark });
      this.$message.success(this.$t('bean.updateSuccess'));
      this.$router.push({ name: `user_request/electricities.show`, params: { id: data.id } });
    }
  }
}

export const route = [
  {
    path: '/user_request/electricities',
    name: 'user_request/electricities.index',
    component: UserRequestElectricities,
    props: {
      type: 'index',
    }
  },
  {
    path: '/user_request/electricities/new',
    name: 'user_request/electricities.new',
    component: UserRequestElectricities,
    props: {
      type: 'new',
    }
  },
  {
    path: '/user_request/electricities/:id',
    name: 'user_request/electricities.show',
    component: UserRequestElectricities,
    props: {
      type: 'show',
    }
  },
  {
    path: '/user_request/electricities/:id/edit',
    name: 'user_request/electricities.edit',
    component: UserRequestElectricities,
    props: {
      type: 'edit'
    },
    meta: {
      can: 'user_requests.update'
    }
  }
]
</script>
